import React from "react";
import { Link } from "gatsby";
import tw, { styled, css } from "twin.macro";
import "styled-components/macro";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import moment from "moment-timezone";
import _ from "lodash";
import { TZ } from "../constants";
import LogoImgBackup from "./LogoImgBackup";

const Container = styled.div`
  ${tw`text-white p-5 `}
  background-color: #1E1E1E
`;

const Header = styled.div`
  ${tw`
    uppercase mt-2.5 mb-4 pb-5 
    border-b-2 border-b-gray-600
  `}
`;

const PostsList = styled.ul`
  ${tw`text-sm box-border`}
`;

const RecentPost = styled.li`
  ${tw`
    [&:not(:last-child)]:mb-4 pb-5
    grid gap-2 w-full grid-cols-[1fr,2fr]
    border-b-2 border-b-gray-600
  `}
`;

const ImageLink = styled(Link)`
  ${tw`hover:brightness-75 transition-[filter] duration-200`}
`;

const TitleLink = styled(Link)`
  ${tw`mb-2 inline-block font-medium`}
`;

const RecentNews = ({ data, color, logoUrl, site }) => {
  let recentPosts = data.recentNews.nodes;
  if (recentPosts.length > 4) {
    recentPosts = recentPosts.slice(0, 4);
  }
  return (
    <Container>
      <Header color={color} site={site}>
        Recent News
      </Header>
      <PostsList>
        {recentPosts.length > 0 ? (
          recentPosts.map(
            (
              { fields, excerpt, frontmatter: { title, hero, date } },
              postIdx
            ) => {
              const pageImage = _.get(hero, "pageImage");
              const formattedSlug = `/news/${moment(date)
                .tz(TZ)
                .format("YYYY-MM-DD")}-${_.kebabCase(title)}`;
              return (
                <RecentPost key={postIdx}>
                  <div>
                    <ImageLink to={formattedSlug}>
                      {pageImage ? (
                        <GatsbyImage
                          image={getImage(pageImage)}
                          alt="thumbnail"
                        />
                      ) : (
                        <LogoImgBackup color={color} src={logoUrl} />
                      )}
                    </ImageLink>
                  </div>
                  <div>
                    <TitleLink to={formattedSlug}>{title}</TitleLink>
                    <div tw="text-gray-400">{excerpt}</div>
                  </div>
                </RecentPost>
              );
            }
          )
        ) : (
          <p>No posts for the time being, please check back in later</p>
        )}
      </PostsList>
    </Container>
  );
};

export default RecentNews;
